import * as React from 'react';
var Loader = function (props) {
    var style = props.style || {};
    var _a = React.useState(false), visible = _a[0], setVisible = _a[1];
    React.useEffect(function () {
        var t = setTimeout(function () {
            setVisible(true);
        }, props.delayDisabled ? 0 : 300);
        return function () {
            clearTimeout(t);
        };
    }, []);
    if (props.centered) {
        style.display = 'flex';
        style.justifyContent = 'center';
        style.width = style.width || '100%';
    }
    if (!visible) {
        return null;
    }
    return (React.createElement("div", { id: "preloader", className: props.styling === 'large' ? 'large' : '', style: style },
        React.createElement("div", { id: "loader", style: { width: props.size, height: props.size }, className: props.white ? 'white' : '' })));
};
export default Loader;
//# sourceMappingURL=Loader.js.map